import { render } from "./TradingRules.vue?vue&type=template&id=bef82832&scoped=true"
import script from "./TradingRules.vue?vue&type=script&lang=js"
export * from "./TradingRules.vue?vue&type=script&lang=js"

import "./TradingRules.vue?vue&type=style&index=0&id=bef82832&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef82832"]])

export default __exports__